import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Button from '../../../../../../../../../../../../components/button';
import {isDirectoryV5AccessPopupShown as setIsDirectoryV5AccessPopupShown} from '../../../../../../../../../../../../../actions/popupActions';

function ContactInfoEditBtn ({history}) {

    const contactDetails = useSelector(state => state.contactDetailsReducer.findContactDetails);
    const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const profile = useSelector(state => state.profileReducer.getProfile);

	const dispatch = useDispatch();

    const handleClick = () => {
	    if(contactDetails.phoneContactEntry.type === "directory"){
		    if(profile.accessStatus.isCustomSchemaAndDirectoryWriteGranted === false){
			    dispatch(setIsDirectoryV5AccessPopupShown(true));
		    } else {
			    history.push('/contact/' + contactDetails.id + '/edit');
		    }
	    } else {
		    history.push('/contact/' + contactDetails.id + '/edit');
	    }
    };

    return (
        <Button onClick={ handleClick } className="btn btn-link p-0 pr-2" disabled={selectedContactsGroup === null || (contactDetails.editable === false && contactDetails.phoneContactEntry.type !== 'directory')}>
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M12.2565 4.07689L14.5 1.83334C15.3588 0.9746 15.7881 0.545232 16.2903 0.403555C16.6454 0.303388 17.0213 0.303388 17.3764 0.403555C17.8786 0.545232 18.3079 0.9746 19.1667 1.83334C20.0254 2.69207 20.4548 3.12144 20.5965 3.62366C20.6966 3.97874 20.6966 4.3546 20.5965 4.70968C20.4548 5.2119 20.0254 5.64127 19.1667 6.5L16.9492 8.7175C15.0027 7.6014 13.3871 5.99799 12.2565 4.07689ZM10.8021 5.53126L2.52306 13.8103C2.098 14.2354 1.88547 14.4479 1.74574 14.709C1.606 14.9701 1.54706 15.2648 1.42917 15.8543L0.647104 19.7646C0.580582 20.0972 0.547321 20.2635 0.641929 20.3581C0.736533 20.4527 0.902829 20.4194 1.23541 20.3529L1.23544 20.3529L1.23545 20.3529L5.14577 19.5709L5.14578 19.5708C5.73522 19.453 6.02995 19.394 6.29104 19.2543C6.55214 19.1145 6.76467 18.902 7.18973 18.477L15.4911 10.1756C13.5955 8.99522 11.9942 7.40501 10.8021 5.53126Z" fill="#314D60"/>
            </svg>
        </Button>
    )
}

export default ContactInfoEditBtn;
